import React from "react";

export default function LoadingSpinner(): React.ReactElement {
	return (
		<div className="Loading_mainContainer">
			<div className="Loading_spinnerContainer">
				<div className="Loading_spinner"></div>
			</div>
			<div className="Loading_text">Loading Screenshot ..</div>
		</div>
	);
}
